import mitt from 'mitt'

export const createWorkEmitter = mitt()

export function fireOpenNextTrackEvent(currentTrackId: number, tracks: Track[]) {
  const currentIndex = tracks.findIndex(track => currentTrackId === track.id)
  const nextTrack = tracks[currentIndex + 1]

  if (nextTrack) {
    createWorkEmitter.emit(`openTrack${nextTrack.id}`)
  }
}
